/* Minimal behaviour for AI replica sections (announcement, header, carousels, slideshow, video). */
(function () {
  'use strict';
  var ss = { get: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
             set: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} } };
  var body = document.body;

  /* ---------- Announcement bar ---------- */
  function initAnnouncement(bar) {
    if (bar.dataset.aiInit) return; bar.dataset.aiInit = '1';
    var items = Array.prototype.slice.call(bar.querySelectorAll('.announcement'));
    var idx = 0, speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000, timer = null;
    function show(i) {
      if (!items.length) return;
      idx = (i + items.length) % items.length;
      items.forEach(function (el, n) { el.classList.toggle('announcement--inactive', n !== idx); });
    }
    function start() { stop(); if (items.length > 1) timer = setInterval(function () { show(idx + 1); }, speed); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    var prev = bar.querySelector('.announcement-button--previous'), next = bar.querySelector('.announcement-button--next');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); start(); });
    if (next) next.addEventListener('click', function () { show(idx + 1); start(); });
    bar.addEventListener('mouseenter', stop); bar.addEventListener('mouseleave', start);
    var close = bar.querySelector('.announcement-close');
    if (close) close.addEventListener('click', function () { body.classList.add('announcement-closed'); ss.set('ai-announcement-closed', '1'); updateHeaderHeight(); });
    if (ss.get('ai-announcement-closed') === '1') body.classList.add('announcement-closed');
    show(0); start();
  }

  /* ---------- Header ---------- */
  var headerSection = null;
  function updateHeaderHeight() {
    if (!headerSection) return;
    var h = headerSection.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--theme-header-height', h + 'px');
    var ann = document.querySelector('.section-announcement-bar');
    var ah = (ann && !body.classList.contains('announcement-closed')) ? ann.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--ai-announcement-height', ah + 'px');
  }
  function initHeader(ph) {
    if (ph.dataset.aiInit) return; ph.dataset.aiInit = '1';
    headerSection = ph.closest('.shopify-section') || ph.parentElement;
    var pageheader = ph.querySelector('.pageheader');
    var permitted = pageheader && pageheader.classList.contains('pageheader--transparent-permitted');
    updateHeaderHeight();
    if (window.ResizeObserver) new ResizeObserver(updateHeaderHeight).observe(headerSection);
    window.addEventListener('resize', updateHeaderHeight);

    var pw = document.querySelector('.page-wrapper');
    function scrollPos() { var y = window.scrollY || document.documentElement.scrollTop || 0; if (pw && pw.scrollTop > y) y = pw.scrollTop; return y; }
    function onScroll() {
      if (!permitted) return;
      pageheader.classList.toggle('pageheader--transparent', scrollPos() < 10);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    if (pw) pw.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Desktop mega menu hover */
    var nav = ph.querySelector('#main-nav');
    var hideTimer = null;
    if (nav) {
      var items = nav.querySelectorAll('.navigation__tier-1 > .navigation__item');
      Array.prototype.forEach.call(items, function (li) {
        var hasDrop = li.querySelector('.navigation__tier-2-container');
        li.addEventListener('mouseenter', function () {
          if (window.innerWidth < 768) return;
          clearTimeout(hideTimer);
          Array.prototype.forEach.call(items, function (o) { if (o !== li) { o.classList.remove('navigation__item--show-children'); var a0 = o.querySelector(':scope > .navigation__link'); if (a0 && a0.hasAttribute('aria-expanded')) a0.setAttribute('aria-expanded', 'false'); } });
          if (hasDrop) {
            li.classList.add('navigation__item--show-children');
            var a = li.querySelector(':scope > .navigation__link'); if (a) a.setAttribute('aria-expanded', 'true');
            headerSection.classList.add('section-header--nav-hover');
          } else {
            headerSection.classList.remove('section-header--nav-hover');
          }
        });
        li.addEventListener('mouseleave', function () {
          hideTimer = setTimeout(function () {
            li.classList.remove('navigation__item--show-children');
            var a = li.querySelector(':scope > .navigation__link'); if (a && a.hasAttribute('aria-expanded')) a.setAttribute('aria-expanded', 'false');
            if (!nav.querySelector('.navigation__item--show-children')) headerSection.classList.remove('section-header--nav-hover');
          }, 120);
        });
      });
      nav.addEventListener('click', function (e) {
        var t = e.target.closest('.navigation__children-toggle');
        if (t && window.innerWidth >= 768) { e.preventDefault(); }
      });
    }

    /* Search overlay */
    Array.prototype.forEach.call(ph.querySelectorAll('.show-search-link'), function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        body.classList.add('show-search');
        var input = ph.querySelector('.main-search__input');
        if (input) setTimeout(function () { input.focus(); }, 50);
      });
    });
    var closeSearch = function () { body.classList.remove('show-search'); };
    var sc = ph.querySelector('.main-search__close'); if (sc) sc.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeSearch(); closeMobile(); } });

    /* Mobile drawer */
    var drawer = ph.querySelector('.mobile-navigation-drawer');
    var drawerNav = drawer && drawer.querySelector('.mobile-navigation-drawer__nav');
    var title = drawer && drawer.querySelector('.mobile-nav-title');
    function buildDrawer() {
      if (!drawerNav || drawerNav.childElementCount || !nav) return;
      var clone = nav.querySelector('.navigation').cloneNode(true);
      clone.removeAttribute('id');
      Array.prototype.forEach.call(clone.querySelectorAll('[id]'), function (el) { el.id = el.id + '-m'; });
      drawerNav.appendChild(clone);
      clone.addEventListener('click', function (e) {
        var tog = e.target.closest('.navigation__children-toggle');
        var link = e.target.closest('.navigation__link');
        var li = (tog || link) && (tog || link).parentElement;
        if (!li || !li.querySelector(':scope > .navigation__tier-2-container, :scope > .navigation__tier-3-container')) return;
        if (link && !tog && !li.classList.contains('navigation__item--with-children')) return;
        e.preventDefault();
        if (li.parentElement.classList.contains('navigation__tier-1')) {
          li.classList.add('navigation__item--open');
          drawer.classList.add('mobile-navigation-drawer--child-open');
          if (title) title.textContent = (li.querySelector(':scope > .navigation__link') || {}).textContent || '';
        } else {
          li.classList.toggle('navigation__item--open');
        }
      });
    }
    function openMobile() { buildDrawer(); drawer.style.display = 'block'; requestAnimationFrame(function () { body.classList.add('reveal-mobile-nav'); setTimeout(function () { body.classList.add('reveal-mobile-nav--revealed'); }, 350); }); }
    function closeMobile() { if (!body.classList.contains('reveal-mobile-nav')) return; body.classList.remove('reveal-mobile-nav', 'reveal-mobile-nav--revealed'); if (drawer) { drawer.classList.remove('mobile-navigation-drawer--child-open'); Array.prototype.forEach.call(drawer.querySelectorAll('.navigation__item--open'), function (x) { x.classList.remove('navigation__item--open'); }); } }
    Array.prototype.forEach.call(ph.querySelectorAll('.mobile-nav-toggle'), function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); if (body.classList.contains('reveal-mobile-nav') || body.classList.contains('show-search')) { closeMobile(); closeSearch(); } else { openMobile(); } });
    });
    var back = drawer && drawer.querySelector('.mobile-nav-back');
    if (back) back.addEventListener('click', function (e) { e.preventDefault(); drawer.classList.remove('mobile-navigation-drawer--child-open'); Array.prototype.forEach.call(drawer.querySelectorAll('.navigation__tier-1 > .navigation__item--open'), function (x) { x.classList.remove('navigation__item--open'); }); });
  }

  /* ---------- Carousel slider ---------- */
  function initCarousel(c) {
    if (c.dataset.aiInit) return; c.dataset.aiInit = '1';
    var slider = c.querySelector('.slider'); if (!slider) return;
    var prev = c.querySelector('.slider-nav__btn[name="prev"]'), next = c.querySelector('.slider-nav__btn[name="next"]');
    function update() {
      var max = slider.scrollWidth - slider.clientWidth - 2;
      if (prev) prev.disabled = slider.scrollLeft <= 2;
      if (next) next.disabled = slider.scrollLeft >= max;
    }
    function step(dir) {
      var item = slider.querySelector('.slider__item');
      var w = item ? item.getBoundingClientRect().width : slider.clientWidth;
      var per = Math.max(1, Math.round(slider.clientWidth / w));
      slider.scrollBy({ left: dir * w * per, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    slider.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update); update();
    /* drag to scroll on desktop */
    var down = false, sx = 0, sl = 0, moved = false;
    slider.addEventListener('mousedown', function (e) { down = true; moved = false; sx = e.pageX; sl = slider.scrollLeft; slider.classList.add('is-grabbing'); });
    window.addEventListener('mouseup', function () { if (down) { down = false; slider.classList.remove('is-grabbing'); } });
    slider.addEventListener('mousemove', function (e) { if (!down) return; var dx = e.pageX - sx; if (Math.abs(dx) > 5) moved = true; slider.scrollLeft = sl - dx; });
    slider.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    Array.prototype.forEach.call(slider.querySelectorAll('img, a'), function (el) { el.setAttribute('draggable', 'false'); });
  }

  /* ---------- Slideshow (testimonials) ---------- */
  function initSlideshow(s) {
    if (s.dataset.aiInit) return; s.dataset.aiInit = '1';
    var track = s.querySelector('.slideshow'); var slides = s.querySelectorAll('.slideshow__slide');
    if (!track || slides.length < 2) return;
    var idx = 0, timer = null, speed = (parseInt(s.dataset.speed, 10) || 5) * 1000;
    function go(i) {
      idx = (i + slides.length) % slides.length;
      Array.prototype.forEach.call(slides, function (sl, n) { sl.classList.toggle('is-active', n === idx); sl.setAttribute('aria-hidden', n === idx ? 'false' : 'true'); });
      track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: 'auto' });
    }
    function start() { stop(); if (s.dataset.autoplay === 'true') timer = setInterval(function () { go(idx + 1); }, speed); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    var p = s.querySelector('.slideshow-nav__btn[name="prev"]'), n = s.querySelector('.slideshow-nav__btn[name="next"]');
    if (p) p.addEventListener('click', function () { go(idx - 1); start(); });
    if (n) n.addEventListener('click', function () { go(idx + 1); start(); });
    s.addEventListener('mouseenter', stop); s.addEventListener('mouseleave', start);
    window.addEventListener('resize', function () { go(idx); });
    go(0); start();
  }

  /* ---------- Background video ---------- */
  function initVideo(v) {
    if (v.dataset.aiInit) return; v.dataset.aiInit = '1';
    var section = v.closest('.video-section');
    v.muted = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls');
    v.addEventListener('playing', function () { if (section) section.classList.add('video-section--played'); });
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }

  function initAll(root) {
    root = root || document;
    Array.prototype.forEach.call(root.querySelectorAll('.ai-v announcement-bar'), initAnnouncement);
    Array.prototype.forEach.call(root.querySelectorAll('.ai-v page-header'), initHeader);
    Array.prototype.forEach.call(root.querySelectorAll('.ai-v carousel-slider'), initCarousel);
    Array.prototype.forEach.call(root.querySelectorAll('.ai-v slide-show'), initSlideshow);
    Array.prototype.forEach.call(root.querySelectorAll('.ai-v .video-section video'), initVideo);
  }
  document.documentElement.classList.add('ai-js');
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
